import React, { useEffect } from 'react';
import { Form } from 'antd';
import { Link } from 'react-router-dom';
import CustomerCheckInput from '../../inputs/customerCheckInput/CustomerCheckInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import useAdditionalServices from '../../../hooks/queryHooks/useAdditionalServices';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import { ReactComponent as AgroBaggage } from '../../../../resources/images/svg/agroBaggage.svg';
import { ReactComponent as CivilBaggage } from '../../../../resources/images/svg/civilBaggage.svg';
import { ReactComponent as Baggage } from '../../../../resources/images/svg/baggage.svg';
import { ReactComponent as Info } from '../../../../resources/images/svg/info.svg';

const baggageIcons = {
  baggage_02: <AgroBaggage className="w-7 h-7" />,
  baggage_01: <CivilBaggage className="w-7 h-7" />,
};

function PassengerServicesForm({
  index, form, handlePassengerPrice, passenger, rideId,
}) {
  const { setServices } = useBooking();
  const { additionalServices, fetchServices } = useAdditionalServices({
    passengerAgeRangeId: 1,
    seatClassId: passenger?.seat_class,
    seatNumber: passenger?.seat_number,
    statementSeatId: passenger?.seat_id,
    carriageId: passenger?.carriage_id,
    id: rideId,
    setServices,
  });
  const servicesWatch = Form.useWatch(['passengers', index, 'additional_services'], form);
  const { trans } = useTranslation();
  useEffect(() => {
    handlePassengerPrice(passenger, index);
  }, [JSON.stringify(servicesWatch)]);

  return (
    <>
      <div>
        <div className="flex gap-2 items-center">
          <CustomerCheckInput
            className="no-padding pointer-events-none"
            name={['additional_services', 'free']}
            label={trans('free_baggage')}
            defaultChecked
          />
          <Baggage className="w-7 h-7" />
        </div>
        <p className="m-0 text-[12px]">
          {trans('free_baggage_description')}
        </p>
      </div>
      <DefaultButton
        type="button"
        onClick={fetchServices}
        className="flex items-center text-base m-0 font-big-bold px-12 w-fit py-4 bg-white !text-primary"
      >
        {trans('additional_services')}
      </DefaultButton>
      <div className="flex flex-col lg:flex-row lg:gap-x-5 flex-wrap">
        {additionalServices?.map((service) => (
          <div className="flex gap-2 items-center">
            <CustomerCheckInput
              className="no-padding"
              key={service?.id}
              name={[index, 'additional_services', `${service?.id}`]}
              label={`${trans(service.serviceCode) !== service.serviceCode
                ? trans(service.serviceCode) : service.serviceName} (${service?.amount}${trans('gel')})`}
            />
            {
                        baggageIcons?.[service.serviceCode]
                    }
          </div>
        ))}
        {!!additionalServices?.length && (
        <div className="flex gap-2 items-center">
          <Info />
          <p className="text-[12px] m-0">
            {trans('additional_services_description')}
            {' '}
            <Link to={{
              pathname: '/ka/info-content',
              search: '?tab=terms',
            }}
            >
              {trans('details')}
            </Link>
          </p>
        </div>
        )}
      </div>
    </>
  );
}

export default PassengerServicesForm;
